import styled from 'styled-components';

const Chips = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ededed;
  color: #333333;

  padding: 2px 12px;
  border-radius: 16px;
  width: fit-content;

  text-align: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`;

export default Chips;
